<template>
  <div class="loader-container">
    <div ref="container" class="logo-spinner mb-6">
      <img
        :src="logoUrl"
        :alt="config.name + ' logo'"
        class="spinning-logo w-[40px] h-[40px]"
      />
    </div>
    <span><strong>Loading{{ dots }}</strong></span>
  </div>
</template>

<script>
  export default {
    name: 'LoadingNew',
    props: {
      loop: { type: Boolean, default: true },
      autoplay: { type: Boolean, default: true },
    },
    data () {
      return {
        dots: '',
        intervalId: null
      }
    },
    computed: {
      config () {
        return this.$store.state.config
      },
      logoUrl () {
        return '/images/datascouts-logo-no-text.svg'
      }
    },
    mounted () {
      // Animate dots
      let count = 0;
      this.intervalId = setInterval(() => {
        count = (count + 1) % 4; // 0,1,2,3
        this.dots = '.'.repeat(count);
      }, 500);
    },
    beforeUnmount () {
      if (this.intervalId) {
        clearInterval(this.intervalId)
      }
    }
  };
</script>
<style lang="scss" scoped>
  .loader-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    text-align: center;
    align-content: center;
    flex-wrap: wrap;
    justify-content: center;

    span {
      margin-top: -1.25rem;
    }
  }

  .logo-spinner {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .spinning-logo {
    animation: spin 2s linear infinite;
    object-fit: contain;
    border-radius: 50%;
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>
